export default __webpack_public_path__ + "static/media/xd.e61b658c.png";